export const headerStyle = {
  backgroundColor: "#141414",
  display: "flex",
  alignItems: "center",
  padding: "0 20px",
  position: "sticky",
  top: "0",
  left: "0",
  right: "0",
  zIndex: "998",
  // height: '90px'
};

export const logoStyle = {
  marginRight: "20px",
  marginTop: "26px",
};

export const logoImageStyle = {
  height: "40px",
};

export const menuDesktopStyle = {
  display: "none",
  flex: 1,
  justifyContent: "start",
};

export const menuMobileStyle = {
  flex: 1,
  textAlign: "right",
};

export const loginButtonStyle = {
  marginLeft: "15px",
  backgroundColor: "#08FF96",
  borderColor: "#08FF96",
  width: "auto",
  height: "50px",
  padding: "14px 12px 14px 12px",
  gap: "10px",
  borderRadius: "5px",
  fontFamily: '"Anybody", sans-serif',
  fontSize: "16px",
  fontWeight: "400",
  lineHeight: "21.78px",
  textAlign: "center",
};

export const menuStyle = {
  backgroundColor: "#141414",
  color: "white",
  border: "none",
  fontFamily: '"Anybody", sans-serif',
  fontSize: "18px",
  fontWeight: 300,
  textAlign: "center",
};

export const menuItemStyle = {
  color: "white",
  marginLeft: "10px",
};

export const activeStyle = {
  color: "#08FF96",
};

export const drawerBodyStyle = {
  backgroundColor: "#141414",
};
